import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DateFnsUtils from "@date-io/date-fns";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";

// Custom Component
import Legend from "../../../Legend/Legend";
import LockScreenLoading from "../../../LockScreenLoading/LockScreenLoading";
import AttachmentChip from "../../../Chip/AttachmentChip";

import { ckEditorToolbar } from "../../../../global/ckEditor";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";
import { saveRFI } from "../../../../dataSource/rfi";

const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const RFIComment = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    postCommentConfirmAction,
    rfi_seq,
    submissionValue,
    submissionCommentValue,
    setSubmissionCommentValue,
    userStageAction,
    viewFileAction,
    noneditViewFileAction,
    downloadFileAction,
  } = props;
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [onLoad, setOnLoad] = useState(true);
  const [postFlag, setPostFlag] = useState(false);

  // const [submissionCommentValue, setSubmissionCommentValue] = useState({});

  // Handle Form Input
  const ckeditorHandleChange = (name) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...submissionCommentValue };
    data.rficomment = inputData;
    setSubmissionCommentValue({ ...submissionCommentValue, ...data });
    dispatch({
      type: "ADD_RFI_COMMENT_SUBMISSION_VALUE",
      data: { ...submissionCommentValue, ...data },
    });
  };

  const buildFileRecord = (fileType, fileUploadRecord) => {
    const val = { ...submissionCommentValue };
    fileUploadRecord.modifydate = "";
    val.files.push(fileUploadRecord);

    setSubmissionCommentValue({ ...setSubmissionCommentValue, ...val });
    dispatch({
      type: "ADD_RFI_COMMENT_SUBMISSION_VALUE",
      data: { ...submissionCommentValue, val },
    });
  };

  const savePDF = () => {
    setLockScreenLoadingOpen(true);
    let submitbody = {};
    submitbody.ref_no = submissionValue.manual_ref_no;
    submitbody.rfi_seq = submissionValue.rfi_seq;
    submitbody.transmittal = [];
    saveRFI(submitbody).then((res) => {
      buildFileRecord("rficomment", res.data.data[0]);
      setLockScreenLoadingOpen(false);
    });
  };

  useEffect(() => {
    if (
      submissionCommentValue.rficomment === "" &&
      submissionCommentValue.files.length === 0
    ) {
      setPostFlag(false);
    } else {
      setPostFlag(true);
    }
  }, [submissionCommentValue]);

  // CKEditor Config
  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            Comment Information
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="subtitle1" className={classes.subHeaderText}>
            History of Comment:
          </Typography>
          {submissionValue.comments && submissionValue.comments.length > 0 ? (
            submissionValue.comments.map((obj, index) => {
              return (
                <Box
                  key={index}
                  border={1}
                  borderColor={"grey.500"}
                  style={{ padding: "5px" }}
                >
                  <div key={index}>
                    <Grid item xs={12}>
                      <div className={classes.itemText}>
                        Comment by: {obj.createuser} At {obj.createdate}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <CKEditor
                        editor={ClassicEditor}
                        data={obj.rficomment}
                        config={editorConfiguration}
                        disabled={true}
                      />
                    </Grid>
                    <Grid>
                      <AttachmentChip
                        key={obj.files[0].FILE_SEQ}
                        id={obj.files[0].FILE_SEQ}
                        filename={obj.files[0].FILENAME}
                        fileSize={obj.files[0].FILESIZE}
                        fileExtension={obj.files[0].EXTENSION}
                        viewFileAction={() =>
                          noneditViewFileAction("master", obj.files[0].FILE_SEQ)
                        }
                        downloadFileAction={() =>
                          downloadFileAction("master", obj.files[0].FILE_SEQ)
                        }
                        fileRemoveAction={null}
                      />
                    </Grid>
                    <br />
                  </div>
                </Box>
              );
            })
          ) : (
            <h3 style={{ color: "red" }}>No History Comment</h3>
          )}

          {userStageAction.IS_COMMENTABLE === "Y" && (
            <>
              <Box
                border={!postFlag && !onLoad ? 1 : 0}
                borderColor={!postFlag && !onLoad ? "error.main" : "grey.500"}
              >
                <Legend id="comment-content" label="Comment">
                  <CKEditor
                    editor={ClassicEditor}
                    data={submissionCommentValue.rficomment || ""}
                    name={"comment"}
                    onChange={ckeditorHandleChange("comment")}
                    config={editorConfiguration}
                  />
                  {
                    <Legend id="file_attachment" label="PREVIEW RFI">
                      {userStageAction.IS_COMMENTABLE === "Y" ? (
                        <div className={classes.messageAttachmentArea}>
                          <Grid item xs={12}>
                            {submissionCommentValue.files.length > 0 ? (
                              submissionCommentValue.files.map((obj, index) => {
                                return (
                                  <AttachmentChip
                                    key={obj.file_seq}
                                    id={obj.file_seq}
                                    filename={obj.filename}
                                    fileSize={obj.filesize}
                                    fileExtension={obj.extension}
                                    viewFileAction={() =>
                                      viewFileAction("master", obj.file_seq)
                                    }
                                    downloadFileAction={() =>
                                      downloadFileAction("master", obj.file_seq)
                                    }
                                    fileRemoveAction={null}
                                  />
                                );
                              })
                            ) : (
                              <h3 style={{ color: "red" }}>No Preview Files</h3>
                            )}
                          </Grid>
                        </div>
                      ) : (
                        <h3 style={{ color: "red" }}>
                          You have no permission to read file attachments
                        </h3>
                      )}
                    </Legend>
                  }
                </Legend>
              </Box>
              {!postFlag && !onLoad ? (
                <Typography
                  variant="caption"
                  color="error"
                  className={classes.errorMsg}
                >
                  Preview RFI file / Comment is required
                  <br />
                </Typography>
              ) : (
                ""
              )}

              {submissionCommentValue.files.length === 0 && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.formBtn}
                  onClick={savePDF}
                >
                  Generate Preview RFI
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                className={classes.formBtn}
                onClick={() => {
                  setOnLoad(!onLoad);
                  postCommentConfirmAction(rfi_seq, postFlag);
                }}
              >
                Post Comment
              </Button>
            </>
          )}
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RFIComment;
